export default "__VITE_ASSET__BxwZJ_8k__"